import { useParams, useLocation, useSearchParams } from "react-router-dom";
import ThreadView from "../../components/threads/ThreadView";
import { ThreadProvider } from "../../context/ThreadContext";

/**
 * Thread View Page
 * Displays fight discussion thread using the ThreadView component
 * Requirements: 2.1, 2.3, 7.1, 7.5
 */
const ThreadViewPage = () => {
  const { threadId } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const {
    fightId: stateFightId,
    threadData,
    fromFightCard,
  } = location.state || {};

  // Extract parameters from query string (for notification navigation)
  const messageId = searchParams.get("messageId");
  const replyId = searchParams.get("replyId");
  const queryFightId = searchParams.get("fightId");

  // Use fightId from state first, then from query params
  const fightId =
    stateFightId || (queryFightId ? parseInt(queryFightId) : null);

  /**
   * Handle thread load success
   */
  const handleThreadLoad = (threadResponse) => {
    if (process.env.NODE_ENV === "development") {
      console.log("🧵 Thread loaded in page:", {
        threadId: threadResponse.thread?.id,
        fightId: threadResponse.fight?.FightId,
        fromFightCard,
        messageId,
        replyId,
      });
    }
  };

  /**
   * Handle thread load error
   */
  const handleThreadError = (error) => {
    if (process.env.NODE_ENV === "development") {
      console.error("❌ Thread error in page:", error);
    }
  };

  return (
    <ThreadProvider>
      <ThreadView
        threadId={threadId}
        fightId={fightId}
        initialThreadData={threadData}
        highlightMessageId={messageId}
        highlightReplyId={replyId}
        onThreadLoad={handleThreadLoad}
        onError={handleThreadError}
      />
    </ThreadProvider>
  );
};

export default ThreadViewPage;
